module.exports = "<!doctype html>\n<html lang=\"en\">\n<head>\n  <meta charset=\"utf-8\">\n  <title>Website Title</title>\n  <base href=\"/\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n  <link rel=\"icon\" type=\"image/x-icon\" href=\"favicon.ico\">\n   <script src=\"https://checkout.razorpay.com/v1/checkout.js\"></script> \n</head>\n<body> \n  \n\n  <br>\n  <br>\n  <!-- <button id=\"rzp-button1\" (click)=\"payWithRazor();\">Pay</button> -->\n</body>\n</html>"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/checkout-form/checkout-form.component.html
// module id = ./src/app/allocation/checkout-form/checkout-form.component.html
// module chunks = main